(function () {
  'use strict';

  function commentEditor(workflowStateService) {
      return {
          restrict: 'E',
          templateUrl: 'workflow/directives/templates/commentEditor.html',
          scope: {
              placeholder: '@',
              path: '@',
              savePrompt: '@',
              editCommentModel: '=',
              editComment: '&',
              cancelEditComment: '&',
              partners: '='
          },
          link: function (scope, element, attrs) {
              scope.originalPartners = scope.partners || workflowStateService.getPartnersForPath(scope.path).filter(function (p) {
                return p.Access.View && !p.IsPrivate;
              });
              scope.filteredPartners = scope.originalPartners;
              scope.partnerSearchText = "";

              scope.saveAction = function () {
                scope.editCommentModel.targetUsers = getTargetUsers(scope.editCommentModel.saveCommentText);
                scope.editComment();
              }

              function getTargetUsers(text) {
                  var targetUsers = {};
                  var regex = /\b\+?\w+[\.-]?\w+@\w+[\.-]?\w+\.\w{2,3}/mg;
                  var str = text;
                  var m;
                  while ((m = regex.exec(str)) !== null) {
                      // This is necessary to avoid infinite loops with zero-width matches
                      if (m.index === regex.lastIndex) {
                          regex.lastIndex++;
                      }
                      // The result can be accessed through the `m`-variable.
                      m.forEach(function (match) {
                          if (match) {
                            var matchPartner = scope.originalPartners.find(function (p) { return p.UserName === match; });
                            if (matchPartner) {
                              targetUsers[match] = matchPartner.Id;
                          }
                        }
                     });
                  }

                  return targetUsers;
              }

              scope.cancelAction = function () {
                  scope.cancelEditComment();
              }

              scope.keyUp = function(event) {
                  if (scope.path.indexOf('InternalContent') > -1) {
                      return;
                  }

                  var eventElem = $(event.target)[0];
                  // if (Math.ceil(eventElem.value.length / 40) > $(eventElem).attr('rows')) {
                  //     $(eventElem).attr('rows', Math.ceil(eventElem.value.length / 40));
                  // }

                  var caret = getCaretPosition(eventElem);
                  var result = /\S+$/.exec(eventElem.value.slice(0, caret.end));
                  var lastWord = result ? result[0] : null;

                  if (lastWord && lastWord[0] === '@') {
                      scope.showDropdown = true;
                  } else {
                      scope.showDropdown = false;
                  }

                  if (scope.showDropdown) {
                      //scope.partnerSearchText += mapKeyPressToActualCharacter(event.shiftKey, event.keyCode) || '';
                      scope.partnerSearchText = lastWord;
                  } else {
                      scope.partnerSearchText = "";
                  }

                  if (lastWord) {
                      scope.filteredPartners = scope.originalPartners.filter(function (p) {
                        var comparisonValue = lastWord.slice(1, lastWord.length - 1);
                          var name = p.Contact.FirstName + p.Contact.LastName;
                          return name.indexOf(comparisonValue) > -1 || p.UserName.indexOf(comparisonValue) > -1;
                      })
                  }
              };

              function getCaretPosition(ctrl) {
                  var start, end;
                  if (ctrl.setSelectionRange) {
                      start = ctrl.selectionStart;
                      end = ctrl.selectionEnd;
                  } else if (document.selection && document.selection.createRange) {
                      var range = document.selection.createRange();
                      start = 0 - range.duplicate().moveStart('character', -100000);
                      end = start + range.text.length;
                  }
                  return {
                      start: start,
                      end: end
                  }
              }

              scope.selectPartner = function (partner) {
                  console.log(partner);
                  console.log(scope.partnerSearchText);
                  scope.editCommentModel.saveCommentText = scope.editCommentModel.saveCommentText.replace(scope.partnerSearchText, '+' + partner.UserName);
                  scope.showDropdown = false;
                  $(element).find('textarea').focus();
                  scope.filteredPartners = scope.originalPartners;
              }

              function mapKeyPressToActualCharacter(isShiftKey, characterCode) {
                  if ( characterCode === 27 || characterCode === 8 || characterCode === 9 || characterCode === 20 || characterCode === 16 || characterCode === 17 || characterCode === 91 || characterCode === 13 || characterCode === 92 || characterCode === 18 ) {
                      return false;
                  }
                  if (typeof isShiftKey != "boolean" || typeof characterCode != "number") {
                      return false;
                  }
                  var characterMap = [];
                  characterMap[192] = "~";
                  characterMap[49] = "!";
                  characterMap[50] = "@";
                  characterMap[51] = "#";
                  characterMap[52] = "$";
                  characterMap[53] = "%";
                  characterMap[54] = "^";
                  characterMap[55] = "&";
                  characterMap[56] = "*";
                  characterMap[57] = "(";
                  characterMap[48] = ")";
                  characterMap[109] = "_";
                  characterMap[107] = "+";
                  characterMap[219] = "{";
                  characterMap[221] = "}";
                  characterMap[220] = "|";
                  characterMap[59] = ":";
                  characterMap[222] = "\"";
                  characterMap[188] = "<";
                  characterMap[190] = ">";
                  characterMap[191] = "?";
                  characterMap[32] = " ";
                  var character = "";
                  if (isShiftKey) {
                      if ( characterCode >= 65 && characterCode <= 90 ) {
                          character = String.fromCharCode(characterCode);
                      } else {
                          character = characterMap[characterCode];
                      }
                  } else {
                      if ( characterCode >= 65 && characterCode <= 90 ) {
                          character = String.fromCharCode(characterCode).toLowerCase();
                      } else {
                          character = String.fromCharCode(characterCode);
                      }
                  }
                  return character;
              }
          }
      };
  }

  commentEditor.$inject = ['workflowStateService'];

  angular.module('ecap.workflow').directive('commentEditor', commentEditor);
})();

